import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router';

import MenuList from './MenuList';
import MenuHeader from './MenuHeader';

import './Menu.scss';

const NavMenu: FunctionComponent<{ type: string }> = ({ type }) => {
  let location = useLocation();

  return (
    <div className="menu-wrapper">
      <MenuHeader />
      <MenuList type={type} location={location.pathname} />
    </div>
  );
};

export default NavMenu;
